export const onboardings = '/onboardings';
export const onboardingsBrand = '/onboardings/:brand';

export default {
  onboardings,
  onboardingsBrand,
};
